import register from '../register';

const $$ = document.querySelectorAll.bind( document );

let bullets = $$('.fix-internet__step');
let checkboxes = $$('.fix-internet__checkbox');

function init() {

  // init indexes and active state
  bullets.forEach( el => {
    el.dataset.active = 'false';
    el.dataset.activeIndex = 0;
    let emojis = el.querySelectorAll('.fix-internet__emoji');

    emojis.forEach( ( el, index ) => {
      el.dataset.index = index + 1;
    });
  });

  // add click handlers
  checkboxes.forEach( el => {
    el.addEventListener( 'click', handleCheckboxClick );
  });

}

function handleCheckboxClick( e ) {
  let el = e.currentTarget.parentNode;
  let activeIndex = el.dataset.activeIndex;
  let emojis = el.querySelectorAll('.fix-internet__emoji');
  let activeItem = el.querySelector('.fix-internet__emoji.active');

  if ( activeIndex < emojis.length ) {
    el.dataset.active = 'true';
    if ( activeItem ) {
      activeItem.classList.remove('active');
    }
    ++activeIndex;
    emojis[ activeIndex - 1 ].classList.add('active');
    el.dataset.activeIndex = activeIndex;
    return;
  }

  activeItem.classList.remove('active');
  activeIndex = 0;
  el.dataset.activeIndex = activeIndex;
  el.dataset.active = 'false';
}

register( 'fix-the-internet', init );

export default undefined;
